/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  home: {
    intro: {
      title:
        'Uma Inovação Crucial para a Reabilitação Facial Baseada em Realidade Aumentada',
      text: 'O MEPP é uma ferramenta inovadora de reabilitação facial, destinada a tratar a paralisia facial. Proveniente de pesquisas colaborativas de Quebec, reúne pesquisadores, pacientes, clínicos, tecnólogos e estudantes para melhorar a qualidade de vida das pessoas afetadas por paralisia facial. O MEPP utiliza a realidade aumentada e se baseia em dados comprovados para tornar a reabilitação facial mais acessível.',
      financialTitle: 'Com o apoio financeiro de:',
    },
    description: {
      title: 'A terapia do espelho na reabilitação facial',
      text: 'O MEPP vem com um aplicativo para dispositivos móveis. Ele permite que um/a terapeuta ofereça terapia espelho na reabilitação facial, para pacientes com paralisia facial. O MEPP oferece uma plataforma para que os clínicos gerenciem uma base de exercícios, produzam planos de exercícios individualizados e adicionem vários usuários. Além disso, o site oferece um espaço virtual personalizado que permite às pessoas que precisam de reabilitação realizarem seus exercícios.',
      list: {
        title:
          'Vários estudos foram realizados para testar a usabilidade e a eficácia do MEPP:',
        loading: 'Carregando...',
        error: 'Ocorreu um erro ao carregar!',
      },
    },
    history: {
      title:
        'Cerca de <span style="color:#008EDE;">15,4 milhões</span> de pessoas por ano no mundo terão paralisia facial, causada pela paralisia de Bell ou um AVC.',
      text1:
        'Cerca de 15,4 milhões (M) de pessoas por ano no mundo terão paralisia facial, causada pela paralisia de Bell ou um AVC (Feigin et al, 2022). Isso representa aproximadamente 110.000 e aproximadamente 23.000 pessoas a cada ano no Canadá e em Quebec. Para essas pessoas, a reabilitação é, portanto, essencial para favorecer a recuperação das funções e melhorar sua qualidade de vida. A reabilitação é feita através do trabalho conjunto dos pacientes com profissionais de saúde, especializados na avaliação e reabilitação da paralisia facial. No entanto, para esses profissionais, há muito poucos instrumentos especializados e baseados em evidências atualmente disponíveis. Eles precisam, portanto, trabalhar principalmente explorando, às cegas, uma literatura abundante e disparatada, o que prejudica a eficácia de suas intervenções e pode levar a resultados clínicos inferiores.',
      text2:
        'Para resolver essa questão importante, a equipe de pesquisa formada pela doutora Sarah Martineau, fonoaudióloga e professora adjunta clínica na Universidade de Montreal, pela doutora Karine Marcotte, fonoaudióloga e pesquisadora, e pelo doutor Akram Rahal, otorrinolaringologista e professor clínico na Universidade de Montreal, desenvolveu o Mirror Effect Plus Protocol (MEPP), entre 2017 e 2023. Esta reabilitação, e o site que a acompanha, baseia-se nos princípios de intervenção importantes em paralisia facial, assim como na terapia do espelho. O site integra uma progressão de exercícios e uma ajuda visual para facilitar a reabilitação de pessoas com danos neurológicos no rosto. O MEPP propõe uma abordagem personalizada de duplicação facial, única em relação aos softwares de reabilitação facial disponíveis no mercado. Além disso, os protocolos de reabilitação e os exercícios integrados no site são baseados nas mais recentes evidências científicas. Portanto, esta ferramenta facilita significativamente o trabalho dos profissionais, assim como o processo terapêutico dos pacientes, uma vez que oferece uma estrutura clara, baseada na literatura científica, enquanto facilita o acesso aos exercícios em casa e a tele-reabilitação na área da paralisia facial.',
      persons: {
        person1: {
          name: 'Dra. Sarah Martineau',
          title:
            'Fonoaudióloga e professora assistente clínica na Universidade de Montreal',
        },
        person2: {
          name: 'Dra. Karine Marcotte',
          title: 'Fonoaudióloga e pesquisadora',
        },
        person3: {
          name: 'Dr. Akram Rahal',
          title: 'ORL e professor clínico na Universidade de Montreal',
        },
      },
    },
    donate: {
      title: 'Ajude-nos a garantir que o MEPP seja acessível a todos.',
      text: 'Todas as doações apoiam diretamente o desenvolvimento do MEPP, para que possamos fornecer acesso gratuito às nossas ferramentas para aqueles que mais precisam. Faça uma doação hoje mesmo.',
    },
  },
};
